import { StartAndEnd, TimeWindow } from '@ui/interfaces'
import dayjs from 'dayjs'

export const getStartAndEnd = (timewindow: TimeWindow): StartAndEnd => {
  const [time, unit] = timewindow.relative
  const endTime = dayjs().toDate()

  const startTime = dayjs()
    .subtract(time, unit as dayjs.ManipulateType)
    .toDate()

  return { startTime, endTime }
}
